import PenerimaanAsetApi from "./PenerimaanAsetApi";

export default PenerimaanAsetApi;
